import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/loader/forms-login.svg'
import _imports_1 from '@/assets/loader/logo.svg'
import _imports_2 from '@/assets/loader/login.svg'
import _imports_3 from '@/assets/loader/google-logo.svg'
import _imports_4 from '@/assets/loader/facebook-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-6a6516bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fragment__background" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "fragment__background-image",
    src: _imports_0
  })
], -1))
const _hoisted_2 = { class: "fragment__container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fragment__container-logo-image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fragment__container-main-image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_5 = { class: "fragment__container-data" }
const _hoisted_6 = { class: "container-data" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-data__title" }, "Login or Sign Up", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container-data__subtitle" }, "Login to take diferents quiz, take part in challenge and more.", -1))
const _hoisted_9 = { class: "container-data__button" }
const _hoisted_10 = { class: "container-data__google" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Login with Google")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "container-data__facebook" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Login with Facebook")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fragment", {'fade-out':_ctx.fadeOut}])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, "Login")
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, _hoisted_17)
          ])
        ])
      ])
    ])
  ], 2))
}